// Modules
import React from 'react'
// Application
import IllustrationImage from 'assets/new-login-illustration.svg'

// Component
import Logo from 'assets/logo.svg'
import { Container, Content, Illustration, LogoContainer, LogoNav, Subtitle, Title } from './styles'

type LateralBannerNewLoginProps = {
    name?: string
    bgColor?: string
}

export const LateralBannerNewLogin = ({ bgColor, name }: LateralBannerNewLoginProps) => {
    const title = name
        ? `Boas-vindas ao Nav Dasa, a plataforma de saúde do <span>${name}</span>`
        : 'Boas-vindas ao Nav Dasa, a sua plataforma de saúde'

    return (
        <Container>
            <Content>
                <LogoContainer>
                    <LogoNav alt="Nav Dasa Logo" src={Logo} />
                </LogoContainer>
                <Title bgColor={bgColor ?? undefined} dangerouslySetInnerHTML={{ __html: title }} />
                <Subtitle>Agende exames, consultas, vacinas e acompanhe seus resultados.</Subtitle>
                <Illustration alt="Ilustração" src={IllustrationImage} />
            </Content>
        </Container>
    )
}
